Prelogin = (function (prelogin) {
    prelogin.Home = {};
    const me = prelogin.Home;
    let isTouch = false;
    let speechSounds;

    const playingSounds = [];

    const sounds = {
        flip: `${Jr.getAssetsRoot()}/static/sounds/flip.mp3`,
        pilf: `${Jr.getAssetsRoot()}/static/sounds/pilf.mp3`,
    };

    me.init = function () {
        setupScrollAnimations();

        isTouch = 'touchstart' in document.documentElement;

        $('#section-7 .cluster').on(isTouch ? 'touchend' : 'click', function () {
            if ($(this).hasClass('flipped')) {
                $(this).removeClass('flipped');
                playSoundEffect('pilf');
            } else {
                $(this).addClass('flipped');
                playSoundEffect('flip');
            }
        });

        $('.cluster-audio').each(function () {
            preloadSound($(this));
        });

        $('.cluster').on('click', '.cluster-audio', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const src = $(this).attr('data-audio');
            if (typeof playingSounds[src] !== 'undefined') {
                playingSounds[src].pause();
                playingSounds[src].currentTime = 0;
                delete playingSounds[src];
                speechSounds[src].element.parent().find('.progress').remove();
                speechSounds[src].element.parent().removeClass('playing');
            } else {
                // eslint-disable-next-line no-restricted-syntax
                for (const thisSrc in playingSounds) {
                    if (typeof playingSounds[thisSrc] !== 'undefined') {
                        playingSounds[thisSrc].pause();
                        playingSounds[thisSrc].currentTime = 0;
                        delete playingSounds[thisSrc];
                        speechSounds[thisSrc].element.parent().find('.progress').remove();
                        speechSounds[thisSrc].element.parent().removeClass('playing');
                    }
                }
                const thisSound = speechSounds[src].sound;
                playingSounds[src] = thisSound;
                thisSound.play();
            }

            return false;
        });
    };

    const setupScrollAnimations = () => {
        gsap.registerPlugin(ScrollTrigger);

        // First section
        const careerCrew1 = $('#hero-volt');
        const careerCrew2 = $('#hero-beep-9');
        const careerCrew3 = $('#hero-fact-dragon');
        const careerCrew4 = $('#hero-zuri');
        const heroes = $('.hero-character');
        const finalistBox = $('.codie-finalist');

        gsap.to(heroes, {
            scale: 1,
            scrollTrigger: {
                start: 'top top',
                end: '40',
                scrub: true,
            },
        });

        gsap.to(heroes, {
            opacity: 0,
            scrollTrigger: {
                start: '350',
                end: '720',
                scrub: true,
            },
        });

        gsap.to(careerCrew1, {
            left: '-200',
            scrollTrigger: {
                start: '350',
                end: '720',
                scrub: true,
            },
        });

        gsap.to(careerCrew2, {
            left: '+200',
            scrollTrigger: {
                start: '350',
                end: '720',
                scrub: true,
            },
        });

        gsap.to(careerCrew3, {
            left: '+75',
            scrollTrigger: {
                start: '350',
                end: '720',
                scrub: true,
            },
        });

        gsap.to(careerCrew4, {
            left: '-75',
            scrollTrigger: {
                start: '350',
                end: '720',
                scrub: true,
            },
        });

        gsap.to(finalistBox, {
            scale: '1.1',
            x: '+=100',
            scrollTrigger: {
                start: 'top top',
                end: '40',
                scrub: true,
            },
        });

        gsap.to(finalistBox, {
            x: '+400',
            scale: '.6',
            opacity: 0,
            scrollTrigger: {
                start: '350',
                end: '720',
                scrub: true,
            },
        });

        // Second Section
        const demoBeep = $('#section-4').find('.beep-9');
        const scheduleInputContainer = $('#section-4').find('.schedule-demo-container');

        demoBeep.css('transform', 'scale(0.4) rotate(0deg)').css('opacity', '0').css('margin-left', '-800px');
        gsap.to(demoBeep, {
            marginLeft: '-490px',
            transform: 'scale(1) rotate(360deg)',
            opacity: '1',
            scrollTrigger: {
                start: 'bottom center',
                end: '+=100',
                scrub: true,
            },
        });

        scheduleInputContainer.css('transform', 'scale(0.2)').css('opacity', '0');
        gsap.to(scheduleInputContainer, {
            scale: '1',
            opacity: '1',
            scrollTrigger: {
                start: 'bottom center',
                end: '+=100',
                scrub: false,
            },
        });

        // Section 7
        const clusterTitle = $('#section-7').find('h3');

        clusterTitle.css('transform', 'translate(-1500px, 0px) scale(0.2)').css('opacity', '0');
        gsap.to(clusterTitle, {
            scale: '1',
            transform: 'translate(0px, 0px) scale(1)',
            opacity: '1',
            duration: 1,
            scrollTrigger: {
                trigger: '#section-7 h3',
                scrub: false,
            },
        });
    };

    /*
     * Play the specified sound effect at the specified volume.
     * (Clones the sound)
     */
    const playSoundEffect = function (name) {
        const thisSound = new Audio(sounds[name]);

        thisSound.addEventListener(
            'ended',
            function () {
                $(this).remove();
            },
            false,
        );

        thisSound.play();
    };

    const preloadSound = function (soundElement) {
        const src = $(soundElement).attr('data-audio');

        if (!src) {
            return;
        }

        let sound = document.createElement('audio');
        if ('src' in sound) {
            sound.autoPlay = false;
        } else {
            sound = document.createElement('bgsound');
            sound.volume = -10000;
        }
        sound.src = src;
        document.body.appendChild(sound);

        speechSounds[src] = {};
        speechSounds[src].element = soundElement;
        speechSounds[src].sound = sound;

        sound.addEventListener('ended', function () {
            this.currentTime = 0;
            delete playingSounds[this.src];
            speechSounds[this.src].element.find('.progress').fadeOut(300, function () {
                speechSounds[this.src].element.parent().find('.progress').remove();
                speechSounds[this.src].element.parent().removeClass('playing');
            });
        });

        sound.addEventListener('pause', function () {
            delete playingSounds[this.src];
            this.currentTime = 0;
            speechSounds[this.src].element.find('.progress').fadeOut(300, function () {
                speechSounds[this.src].element.parent().find('.progress').remove();
                speechSounds[this.src].element.removeClass('playing');
            });
        });

        sound.addEventListener('play', function () {
            const { duration } = this;
            speechSounds[this.src].duration = duration;
            $('.cluster .progress').remove();
            const element = $('<div class="progress"></div>');
            speechSounds[this.src].element.parent().append(element);
            speechSounds[this.src].element.parent().addClass('playing');
            speechSounds[this.src].element
                .parent()
                .find('.progress')
                .animate(
                    {
                        bottom: '0%',
                    },
                    duration * 1000,
                    function () {
                        $(this).fadeOut(300, function () {
                            $(this).parent().removeClass('playing');
                            $(this).remove();
                        });
                    },
                );
        });
    };

    return prelogin;
}(Prelogin || {}));
